import { useContext, useEffect, useState } from "react";
import { MobileContext } from "../contexts/MobileContext";

const MOBILE_QUERY = "(max-width: 767px)";

/**
 * Returns true when the device is mobile.
 *
 * SSR: reads from MobileContext (set by server via User-Agent parsing),
 * so the server-rendered HTML already excludes desktop-only resources (videos, etc.).
 *
 * Client: keeps the server value on first paint to match hydration, then updates
 * only on viewport changes (resize/orientation) — avoids remounting hero media.
 */
export function useIsMobile(): boolean {
  const serverIsMobile = useContext(MobileContext);
  const [clientIsMobile, setClientIsMobile] = useState<boolean | null>(null);

  useEffect(() => {
    const mql = window.matchMedia(MOBILE_QUERY);

    const handler = (e: MediaQueryListEvent) => setClientIsMobile(e.matches);
    mql.addEventListener("change", handler);
    return () => mql.removeEventListener("change", handler);
  }, []);

  return clientIsMobile ?? serverIsMobile ?? false;
}
